import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10 card-bordered" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title fs-3 fw-bold" }
const _hoisted_4 = { class: "d-flex my-4" }
const _hoisted_5 = { class: "me-0" }
const _hoisted_6 = { class: "card-body pt-3 pb-10 px-2 px-md-8" }
const _hoisted_7 = { class: "flex items-center justify-center h-100%" }

import MenorModal from "@/components/modals/MenorModal.vue";
import { handleError } from "@/core/helpers/errorHandler";
import { NuevoMenor } from "@/store/models";
import FamiliasModule from "@/store/modules/FamiliasModule";
import moment from "moment";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const moduleFamilias = getModule(FamiliasModule, store);

const selectedMenor = ref<NuevoMenor>();
const isLoading = ref(false);
const error = ref();
error.value = null;

const fetch = async () => {
  try {
    isLoading.value = true;
    error.value = null;
    await moduleFamilias.fetchMenores();
  } catch (err) {
    error.value = err;
    handleError(err);
  } finally {
    isLoading.value = false;
  }
};

const menores = computed(() =>
  moduleFamilias.menores.map((ele) => {
    return {
      ...ele,
      nombreCompleto: [ele.nombre, ele.apellidos].join(" "),
      fechaNacimientoString: ele.fechaNacimiento
        ? moment(ele.fechaNacimiento).format("DD/MM/YYYY")
        : "",
    };
  })
);

onMounted(() => fetch());

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("menores.titulo")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedMenor.value = undefined)),
              "data-bs-toggle": "modal",
              "data-bs-target": "#mau_modal_add_menor"
            }, _toDisplayString(_ctx.$t("global.buttons.nuevo")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          style: {"width":"100%"},
          stripe: "",
          data: _unref(menores),
          "default-sort": { prop: 'nombreCompleto', order: 'ascending' }
        }, {
          empty: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              (error.value)
                ? (_openBlock(), _createBlock(_component_el_empty, {
                    key: 0,
                    description: _ctx.$t('global.errores.carga')
                  }, {
                    default: _withCtx(() => [
                      (error.value)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            size: "small",
                            onClick: fetch
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("global.acciones.reintentar")), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["description"]))
                : (_openBlock(), _createBlock(_component_el_empty, { key: 1 }))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('menores.cabecera.nombreCompleto'),
              sortable: "",
              prop: "nombreCompleto",
              "min-width": "180"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('menores.cabecera.fechaNacimiento'),
              sortable: "",
              prop: "fechaNacimiento",
              "min-width": "180"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.fechaNacimientoString), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('menores.cabecera.tienePatologias'),
              sortable: "",
              prop: "tienePatologias",
              "min-width": "150"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.tienePatologias ? _ctx.$t("global.Si") : _ctx.$t("global.No")), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              width: "60",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "text",
                  onClick: ($event: any) => (selectedMenor.value = scope.row),
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_add_menor"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("global.buttons.editar")), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, isLoading.value]
        ])
      ])
    ]),
    _createVNode(MenorModal, { menor: selectedMenor.value }, null, 8, ["menor"])
  ], 64))
}
}

})